import React, { useEffect } from 'react';
import { Button, Label, FormGroup, Input, Row, Col, Container } from 'reactstrap';
import { useGlobalContext } from '../../context';
import ThemeToggle from '../ThemeToggle/ThemeToggle';

export default function MapFilters({ marketIdArray }) {
    const {
        trafficLayer,
        setTrafficLayer,
        weatherLayer,
        setWeatherLayer,
        displayPolygon,
        setDisplayPolygon,
        routesReadyCheck,
        setRoutesReadyCheck,
        routesDeliveringCheck,
        setRoutesDeliveringCheck,
        routesExpeditedCheck,
        setRoutesExpeditedCheck
    } = useGlobalContext();

    function reset() {
        let trafficCB = document.getElementById('traffic-layer');
        trafficCB.checked = false;
        let weatherCB = document.getElementById('weather-layer');
        weatherCB.checked = false;
        let displayPolygonCB = document.getElementById('polygon');
        displayPolygonCB.checked = false;
        let routeReadyCB = document.getElementById('route-ready');
        routeReadyCB.checked = false;
        let routeDeliveringCB = document.getElementById('route-delivering');
        routeDeliveringCB.checked = false;
        let routeExpeditedCB = document.getElementById('route-expedited');
        routeExpeditedCB.checked = false;
        // let routeAlcoholCB = document.getElementById('route-alcohol');
        // routeAlcoholCB.checked = false;
        setTrafficLayer(false);
        setWeatherLayer(false);
        setDisplayPolygon(false);
        setRoutesReadyCheck(false);
        setRoutesDeliveringCheck(false);
        setRoutesExpeditedCheck(false);
    }

    useEffect(() => {
        reset();
    }, [marketIdArray]);

    return (
        <Container>
            <Row className="align-items-center flex-wrap">
                <Col xs="auto" style={{ marginRight: '1rem' }}>
                    <FormGroup check className="mt-1" style={{ marginTop: '0px' }}>
                        <Label check>
                            <Input
                                type="checkbox"
                                id="traffic-layer"
                                value={trafficLayer}
                                onClick={e => {
                                    setTrafficLayer(!trafficLayer);
                                }}
                            />
                            <span className="form-check-sign" />
                            Traffic
                        </Label>
                    </FormGroup>
                </Col>
                <Col xs="auto" style={{ marginRight: '1rem' }}>
                    <FormGroup check className="mt-1" style={{ marginTop: '0px' }}>
                        <Label check>
                            <Input
                                type="checkbox"
                                id="weather-layer"
                                value={weatherLayer}
                                onClick={() => {
                                    setWeatherLayer(!weatherLayer);
                                }}
                            />
                            <span className="form-check-sign" />
                            Weather
                        </Label>
                    </FormGroup>
                </Col>
                <Col xs="auto">
                    <FormGroup check className="mt-1" style={{ marginTop: '0px' }}>
                        <Label check>
                            <Input
                                type="checkbox"
                                id="polygon"
                                value={displayPolygon}
                                onClick={e => {
                                    setDisplayPolygon(!displayPolygon);
                                }}
                            />
                            <span className="form-check-sign" />
                            Polygons
                        </Label>
                    </FormGroup>
                </Col>
                <Col xs="auto" className="ml-auto">
                    <Button
                        size="sm"
                        color="default"
                        onClick={() => {
                            reset();
                        }}
                    >
                        Clear
                    </Button>
                    <ThemeToggle className="map-theme-toggle" fullWidth />
                </Col>
            </Row>
            <Row>
                <Col xs lg="1">
                    <p style={{ marginTop: '0.15rem' }}>Routes:</p>
                </Col>
                <Col xs lg="2">
                    <FormGroup check className="mt-1" style={{ marginTop: '0px' }}>
                        <Label check>
                            <Input
                                type="checkbox"
                                id="route-ready"
                                onClick={e => {
                                    setRoutesReadyCheck(!routesReadyCheck);
                                }}
                            />
                            <span className="form-check-sign" />
                            Ready
                        </Label>
                    </FormGroup>
                </Col>
                <Col xs lg="2">
                    <FormGroup check className="mt-1" style={{ marginTop: '0px' }}>
                        <Label check>
                            <Input
                                type="checkbox"
                                id="route-delivering"
                                onClick={e => {
                                    setRoutesDeliveringCheck(!routesDeliveringCheck);
                                }}
                            />
                            <span className="form-check-sign" />
                            Delivering
                        </Label>
                    </FormGroup>
                </Col>
                <Col xs lg="2">
                    <FormGroup check className="mt-1" style={{ marginTop: '0px' }}>
                        <Label check>
                            <Input
                                type="checkbox"
                                id="route-expedited"
                                onClick={e => {
                                    setRoutesExpeditedCheck(!routesExpeditedCheck);
                                }}
                            />
                            <span className="form-check-sign" />
                            Expedited
                        </Label>
                    </FormGroup>
                </Col>
                {/* <Col xs lg="2">
          <FormGroup check className="mt-1" style={{ marginTop: '0px' }}>
            <Label check>
              <Input
                type="checkbox"
                id="route-alcohol"
                onClick={e => {
                  setRoutesAlcoholCheck(!routesAlcoholCheck);
                }}
              />
              <span className="form-check-sign" />
              Alcohol
            </Label>
          </FormGroup>
        </Col> */}
            </Row>
        </Container>
    );
}
